module.exports = __webpack_public_path__ + "static/media/comp-drying-s.a2459b1f.jpg";